import { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { supabase } from '../utils/supabase';

import ClientModal from '../components/ClientModal';

import RenderMonitor from '../components/RenderMonitor';

import { CLIENTS_CACHE_KEY, readCache, writeCache } from '../utils/adminCache';



function AdminClientsPage() {

  const navigate = useNavigate();

  const [clients, setClients] = useState([]);

  const [fetching, setFetching] = useState(true);

  const [fetchError, setFetchError] = useState('');

  const [showClientModal, setShowClientModal] = useState(false);



  useEffect(() => {

    const fetchData = async () => {

      setFetching(true);

      setFetchError('');

      const cachedClients = readCache(CLIENTS_CACHE_KEY);

      if (cachedClients) setClients(cachedClients);



      if (cachedClients) {

        setFetching(false);

        return;

      }



      const { data: clientsData, error: clientsError } = await supabase

        .from('clients')

        .select('id, business_name');



      if (clientsError) {

        setFetchError(clientsError.message);

      } else {

        writeCache(CLIENTS_CACHE_KEY, clientsData || []);

        setClients(clientsData || []);

      }

      setFetching(false);

    };

    fetchData();

  }, []);



  if (fetching) {

    return <div className="dashboard-page"><div className="modern-loading">Loading clients…</div></div>;

  }



  if (fetchError) {

    return <div className="dashboard-page"><div className="modern-error">{fetchError}</div></div>;

  }



  return (

    <div className="dashboard-page">

      <RenderMonitor componentName="AdminClientsPage" />

      <div className="modern-flex modern-justify-between modern-items-center modern-mb-6">

        <div>

          <h1 className="modern-title">Clients</h1>

          <p className="modern-subtitle" style={{ marginBottom: 0 }}>{clients.length} client{clients.length !== 1 ? 's' : ''}</p>

        </div>

        <button onClick={() => setShowClientModal(true)} className="modern-button modern-button-brand">

          + Add Client

        </button>

      </div>



      <div className="modern-list-panel">

        {clients.length === 0 ? (

          <div className="modern-list-empty">No clients yet. Add your first client to get started.</div>

        ) : (

          clients.map((client) => (

            <div

              key={client.id}

              className="modern-list-row modern-list-row-clickable"

              onClick={() => navigate(`/client/${client.id}`, { state: { clientName: client.business_name || '' } })}

            >

              <span className="modern-list-row-label">{client.business_name || 'Untitled Client'}</span>

            </div>

          ))

        )}

      </div>



      <ClientModal

        open={showClientModal}

        onClose={() => setShowClientModal(false)}

        onAdd={(id, business_name) => {

          try {

            const raw = localStorage.getItem(CLIENTS_CACHE_KEY);

            const parsed = raw ? JSON.parse(raw) : null;

            const current = Array.isArray(parsed?.data) ? parsed.data : clients;

            const newClient = { id, business_name: business_name || 'New Client' };

            const merged = [{ id: newClient.id, business_name: newClient.business_name }, ...current.filter((c) => c.id !== id)];

            writeCache(CLIENTS_CACHE_KEY, merged);

            setClients(merged);

          } catch {}

          setShowClientModal(false);

          navigate(`/client/${id}`, { state: { clientName: business_name || '' } });

        }}

        existingNames={clients.map((c) => c.business_name || '').filter(Boolean)}

      />

    </div>

  );

}



export default AdminClientsPage;

